import { Box, Heading, Label, Text } from '@medely/ui-kit';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { sanitizeGuaranteedHoursString } from '@mp/utils/sanitizeGuaranteedHoursString';
import React from 'react';
import { AssignmentForAssignmentDetailsGql } from '../../graphql';

export const AssignmentAdditionalOfferDetails = ({
  assignment: inputAssignment,
}: {
  assignment?: FragmentType<typeof AssignmentForAssignmentDetailsGql> | null;
}) => {
  const assignment = parseFragmentData(AssignmentForAssignmentDetailsGql, inputAssignment);

  const items = [
    [
      'Float Requirements',
      assignment?.locations?.length && assignment.locations.length > 1 ? 'Float Assignment' : 'n/a',
    ],
    ['Call Requirements', assignment?.call_requirements ?? 'n/a'],
    [
      'Contract Total Hours',
      assignment?.contract_total_hours
        ? Math.round(parseFloat(assignment.contract_total_hours) * 100) / 100
        : 'n/a',
    ],
    ['Guarantee of Hours', sanitizeGuaranteedHoursString(assignment?.guaranteed_hours_string)],
    ['Facility Cancellation policy', assignment?.cancellation_policy ?? 'n/a'],
  ];

  return (
    <>
      <Heading size="s">Additional offer details</Heading>
      <Box mt={2}>
        {items.map((item, index) => (
          <Box key={item[0]} mb={index < items.length - 1 ? 2 : 0}>
            <Label size="m">{item[0]}</Label>
            <Box mt={0.5}>
              <Text size="m">{item[1]}</Text>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
};
